<template>
  <v-main>
    <v-container fluid>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0">Usuários</v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="mr-n4">
          <v-btn text color="primary" :to="{ name: 'newUser' }">
            <v-icon left>mdi-plus-circle-outline</v-icon> Adicionar usuário
          </v-btn>
        </div>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page.sync="pagination.rowsPerPage"
        :no-data-text="noResultText"
        :no-results-text="noResultText"
        loading-text="Carregando..."
        :loading="loading"
        :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
        :server-items-length="pagination.total"
        :page.sync="pagination.page"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn @click="deleteItem = { id: item.id, text: item.name, show: true }" color="error" fab text small dark>
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.created_at="{ item }">
          {{ item.created_at | moment('DD/MM/YYYY hh:mm:ss') }}
        </template>
      </v-data-table>
    </v-container>
    <delete-modal
      title="Usuário"
      endpoint="users"
      :text="deleteItem.text"
      :id="deleteItem.id"
      v-if="deleteItem.show"
      @canceled="deleteItem.show = false"
      @error="deleteItem.show = false"
      @deleted="deleteItem.show = false; getData()"
    ></delete-modal>
  </v-main>
</template>

<script>
import axios from 'axios'
import DeleteModal from '@/components/DeleteModal'
import { mapGetters } from 'vuex';

export default {
  name: 'users',
  components: {
    DeleteModal
  },
  data: () => ({
    loading: false,
    items: [],
    headers: [
      {
        text: '',
        sortable: false,
        value: 'actions'
      },
      {
        text: 'Nome',
        sortable: false,
        value: 'name'
      },
      {
        text: 'E-mail',
        sortable: false,
        value: 'email'
      },
      {
        text: 'É backoffice',
        sortable: false,
        value: 'isBackoffice'
      },
      {
        text: 'Criado em',
        sortable: false,
        value: 'created_at'
      }
    ],
    pagination: {
      rowsPerPage: 20,
      page: 1,
      total: 0
    },
    deleteItem: {
      text: null,
      id: null,
      show: false
    }
  }),
  computed: {
    ...mapGetters(['emailIsBackoffice']),
    noResultText () {
      return 'Nenhum usuário cadastrado'
    },
    params () {
      let params = '?page[size]=' + this.pagination.rowsPerPage + '&page[number]=' + this.pagination.page
      return params
    }
  },
  watch: {
    params () {
      this.getData()
    }
  },
  methods: {
    getData () {
      let vue = this
      vue.loading = true

      axios.get('users' + vue.params)
        .then(response => {
          vue.items = response.data.data.map(e => {
            e.isBackoffice = this.emailIsBackoffice(e.email)
            return e
          })
          vue.loading = false
          vue.pagination.total = response.data.meta.total
        })
        .catch(() => {
          vue.loading = false
          vue.items = []
          vue.pagination.total = 0
        })
    }
  },
  created () {
    this.getData()
  }
}
</script>
